import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AppInfoService } from 'core/app-info/app-info.service';
import { AppLocalization } from 'src/app/modules/shared/entities/app-localization';

@Component({
  selector: 'app-add-product',
  templateUrl: './add-product.component.html',
  styleUrls: ['./add-product.component.scss'],
  standalone: false
})
export class AddProductComponent implements OnInit {
  productInfo: any;
  appStrings: AppLocalization;
  title: string;
  productForm: UntypedFormGroup;
  result = [];
  currencySymbol: any;

  constructor(
    public dialogRef: MatDialogRef<AddProductComponent>,
    private appInfoService: AppInfoService,
    private fb: UntypedFormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    this.productInfo = data.productInfo;
  }

  ngOnInit() {
    this.appStrings = this.appInfoService.appStrings;
    this.title = this.productInfo.id ? this.appStrings.products_gridEditProduct : this.appStrings.products_gridAddProduct;
    this.currencySymbol = this.appInfoService.currencySymbol;
    this.productForm = this.fb.group({
      partNumber: [this.productInfo.productNumber ?? '', Validators.required],
      description: [
        this.productInfo.description ?? '',
        Validators.compose([
          Validators.maxLength(30),
          Validators.pattern(/.*\S.*/)
        ])],
      quantity: [
        this.productInfo.quantity ?? 1, Validators.required],
      unitNetPrice: [
        this.productInfo.netPrice ? Number(this.productInfo.netPrice.toFixed(2)) : null,
        Validators.compose([
          Validators.maxLength(8),
          Validators.min(0.01)]
        )],
      lineNotes: this.productInfo.lineNotes?.notes ?? '',

    });
  }

  saveInfo() {
    const payload = {
      productNumber: this.productForm.controls.partNumber.value,
      description: this.productForm.controls.description.value || '',
      quantity: this.productForm.controls.quantity.value,
      netPrice: Number(this.productForm.controls.unitNetPrice.value) || null,
      notes: this.productForm.controls.lineNotes.value,
    };
    if (this.productInfo.id) {
      payload['id'] = this.productInfo.id;
    }
    this.close(1, payload);
  }

  /**
   * Returns the index of the pressed button. This should be used by the subscriber function to identify the button
   * @param buttonIndex the index of the pressed button
   */
  close(buttonIndex: number, data?: any): void {
    this.dialogRef.close({ buttonIndex, data });
  }

  /**
   * Removes the whitespaces from begin and end of description control
   * @param value - the value of description control
   */
  trimDescriptionControl(value) {
    value = value.trim();
    this.productForm.controls.description.setValue(value);
  }
}
